import React, { Component } from 'react';
import { base, } from '../../../../config/constants.js'
import { Feed, Icon } from 'semantic-ui-react';
import WhatsappSendMessage from './WhatsappSendMessage'
import ChatBubble from './ChatBubble'


class WhatsAppSingleChatView extends Component {
    constructor(props) {
        super(props);
        this.state = {
           // messages: []
        }
    }

    componentDidMount() {
        console.log("105 >> mount WhatsAppSingleChatView >> ++++ componentDidMount")
        console.log("5.>> WhatsAppSingleChatView chatView +++++ syncMessages")
        console.log("5.>> WhatsAppSingleChatView messages:"+this.props.messages.length)
       // this.syncMessages()
    }

    componentWillUnmount(){
        console.log("106 >>  componentWillUnmount WhatsAppSingleChatView >> ++++ ")
      }

    // syncMessages = () => {
    //     console.log("whtx5 chatView +++++ syncMessages this.props.phone:"+this.props.phone )
    //     base.syncState('whatsapp/' + this.props.phone + "/messages", {
    //     //base.syncState('whatsapp/256772042849/messages/', {
    //         context: this,
    //         state: 'messages',
    //         asArray: true,
    //         queries: {
    //             orderByChild: 'createdDateSeconds',
    //             limitToLast: 30
    //         },
    //         then() {
    //             //console.log("whtx2 messsages:"+JSON.stringify(data,null,3))
    //             // this.setState({ loading: false });
    //             // this.countSupplies();

    //         }
    //     });
    // }

    // componentDidUpdate(prevProps) {
    //     console.log("whtx52 +++++ componentDidUpdate")
    //     console.log("whtx52 prevProps.phone:"+prevProps.phone+" new phone:this.props.phone:"+this.props.phone)
    //     if (prevProps.phone !== this.props.phone) {
    //         this.syncMessages();
    //         //alert("phone changed to:"+this.props.phone)
    //     }else{
    //         console.log("phone not changed")
    //     }
    // }

    render() {

        const ShowFeedImage = (props) => props.message.imageUrl
            ? <Feed.Extra images>
                <a>
                    <img src={props.message.imageUrl} />
                </a>
            </Feed.Extra>
            : ''

        // const singleFeed = this.state.messages.length > 0
        //     ? this.state.messages.map((message) =>
        //         <Feed.Event>
        //             <Feed.Label>
        //                 <Icon name='pencil' />
        //             </Feed.Label>
        //             <Feed.Content>
        //                 <Feed.Date>{message.timeSent}</Feed.Date>
        //                 <Feed.Summary>
        //                     {message.sentText}
        //                 </Feed.Summary>
        //                 <ShowFeedImage message={message} />
        //                 <Feed.Meta>
        //                     <Feed.Like>
        //                         {message.status}
        //                     </Feed.Like>
        //                 </Feed.Meta>
        //             </Feed.Content>
        //         </Feed.Event>
        //     )
        //     : ''

        
        //const singleFeed = this.state.messages.length > 0
        const singleFeed = this.props.messages.length > 0
            ? this.props.messages.map((message) =>
                <ChatBubble key={message.key} message={message} phone={this.props.phone} user={this.props.user}/>
            )
            : ''

        const mainFeed = this.props.messages.length > 0
            ? <div>{singleFeed}</div>
            : ''


        // const mainFeed = this.state.messages.length > 0
        //     ? <Feed>{singleFeed}</Feed>
        //     : ''

        return (<div>
            <h1>{this.props.phone} - {this.props.messages.length}</h1>
            {mainFeed}
            <WhatsappSendMessage
                phone={this.props.phone} user={this.props.user} />
        </div>);
    }
}

export default WhatsAppSingleChatView;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Whatsapp/WhatsAppSingleChatView.js